import { render, staticRenderFns } from "./CardSumToPay.vue?vue&type=template&id=8de04ab2&scoped=true"
import script from "./CardSumToPay.vue?vue&type=script&lang=js"
export * from "./CardSumToPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de04ab2",
  null
  
)

export default component.exports